import axios from 'axios';

import { v2AxiosInstance } from './indexApi';

/**
 * @desc 상단 메뉴 조회
 * @returns {Promise<Object>} - 서버 응답 데이터
 */
export const getTimeStampsLatest = async () => {
  const { data } = await v2AxiosInstance.get(`/timestamps/latest`);
  return data;
};

/**
 * @desc 팝업 조회
 * @returns {Promise<Object>} - 서버 응답 데이터
 */
export const getPopUp = async (date) => {
  const { data } = await v2AxiosInstance.get(`/popup?date=${date}`);
  return data;
};

/**
 * @desc FAQ 조회
 * @returns {Promise<Object>} - 서버 응답 데이터
 */
export const getFaQ = async (queryString) => {
  const { data } = await v2AxiosInstance.get(`/faq?${queryString}`);
  return data;
};

/**
 * @desc 메인 배너 조회
 * @returns {Promise<Object>} - 서버 응답 데이터
 */
export const getBanners = async () => {
  const { data } = await v2AxiosInstance.get(`/banners`);
  return data;
};

/**
 * @desc API 문서 조회
 * @returns {Promise<Object>} - 서버 응답 데이터
 */
export const getApiDocs = async () => {
  const { data } = await axios.get(`${process.env.REACT_APP_IMPS_DOCS}`);
  return data;
};
